import { createContext, Provider, useContext } from 'react';
import { Device } from '../use-market-location/use-market-location';

const context = createContext<Device | null>(null);

export const DeviceProvider = context.Provider as Provider<Device>;

export function useCurrentDevice(): Device {
  const device = useContext(context);
  if (!device) {
    throw new Error('Call to "useDevice" was not wrapped inside "DeviceProvider"');
  }
  return device;
}
